import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-pagination-controls",
  templateUrl: "./pagination-controls.component.html",
  styleUrls: ["./pagination-controls.component.scss"],
  standalone: false,
})
export class PaginationControlsComponent {
  // Total number of results across all pages.
  @Input() total = 0;
  // Current 1-based page.
  @Input() page = 1;
  // Total number of pages.
  @Input() totalPages = 1;
  // Emitted when the user requests the previous page.
  @Output() prev = new EventEmitter<void>();
  // Emitted when the user requests the next page.
  @Output() next = new EventEmitter<void>();
}
